// extracted by mini-css-extract-plugin
export default {"footer":"Lju9FS","left":"RA5OcG","space-between":"I1Rgnc"};